import { render } from "./ShopsSyncsInProgress.vue?vue&type=template&id=47cd0f2c&scoped=true"
import script from "./ShopsSyncsInProgress.vue?vue&type=script&lang=ts"
export * from "./ShopsSyncsInProgress.vue?vue&type=script&lang=ts"

import "./ShopsSyncsInProgress.vue?vue&type=style&index=0&id=47cd0f2c&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-47cd0f2c"

export default script